import React, { useEffect, useState } from 'react';

/* Utilities */
import { trans } from '~/utilities';

export default function ArticleFilter({setFilteredArticles, articles}) {
    const [categories, setCategories] = useState([]);
    const [filters, setFilters] = useState({
        "Algemeen": false,
        "Volkswagen": false,
        "Audi": false,
        "SEAT": false,
        "Škoda": false,
        "VW Bedrijfswagens": false,
    });

    useEffect(() => {
        if (articles) {
            const newCategories = [...categories];

            articles.map((article) => {
                if (typeof article.categories === 'string' || !article.categories) return false;
                article.categories.map((category) => {
                    if (newCategories.includes(category.name)) return;
                    newCategories.push(category.name);
                })
            })
            setCategories(newCategories);
        }
    }, []);

    const updateFilters = (e, key, value) => {
        e.preventDefault();
        const newFilter = {...filters};
        newFilter[key] = !value;

        setFilters(newFilter);
        updateArticles(newFilter);
    }

    const updateArticles = (newFilter) => {
        const activeFilters = [];
        Object.entries(newFilter).map(([key, value]) => {
            if (value === true) activeFilters.push(key);
        });

        if (activeFilters.length > 0) {
            const filteredArticles = articles.filter((article) => {
                if (typeof articles.categories === 'string' || !article.categories) return false;
                let show = false;
                article.categories.map((category) => {
                    if (activeFilters.includes(category.name)) show = true;
                });
                if (show) return article;
                return false;
            });

            setFilteredArticles(filteredArticles);
        }

        if (activeFilters.length === 0) setFilteredArticles(articles);
    }

    return (
        <div className="col-12">
            <div className="d-block d-lg-flex align-items-center mt-2 mb-4">
                <p className="text-base text--md font-weight-medium mb-0 mr-4">{trans('app.content_block.smart_content.filter_label')}</p>
                <div className="nav nav--scroll scroll-start" role="tablist" data-scroll-gradient>
                    <div data-scroll-start></div>
                    {categories && Object.entries(filters).map(([key, value]) => {
                        if (categories.includes(key)) return <button key={key} className={`btn btn--pill  ${value === true && 'is-active'} mt-2 mt-lg-0 mr-1`} onClick={(e) => updateFilters(e, key, value)}>{key}</button>
                        return false;
                    })}
                    <div data-scroll-end></div>
                </div>
            </div>
        </div>
    )
}
